import { setupCache } from 'axios-cache-interceptor'
// @todo review additional config below methods: ['get', 'post'], added only for testing https://dummyapi.online and should not be needed with real baseUrl

export const setupAxiosCache = (axiosInstance, opts = { ttl: 0 }) =>
	setupCache(axiosInstance, {
		ttl: opts.ttl,
		interpretHeader: false,
		methods: ['get', 'post'],
		etag: false, // Disable etag handling
		modifiedSince: false, // Disable last-modified handling
		cacheTakeover: false, // Disable cache takeover
		staleIfError: false // Disable stale-if-error handling
	})
